import a4 from "../assets/A4.jpg";
import a5 from "../assets/A5.jpg";
import flax from "../assets/FlaxSeed.jpg";
import gym from "../assets/gym.jpg";
import hospital2 from "../assets/hospital2.jpg";
import mw from "../assets/mw.jpg";
import newYear from "../assets/Newyear.jpg";
import sabja from "../assets/Sabja.jpg";
import vl from "../assets/VL.jpg";
import logo6 from "../assets/Chemical.jpg";
import web1 from "../assets/web1.png";
import web2 from "../assets/web2.png";
import web3 from "../assets/web3.png";
import web4 from "../assets/web4.png";
import web5 from "../assets/web5.png";
import web6 from "../assets/web6.png";
import logo1 from "../assets/logo1.jpg";
import logo2 from "../assets/logo2.jpg";
import logo3 from "../assets/logo3.jpg";
import logo4 from "../assets/logo4.jpg";
import logo5 from "../assets/logo5.jpg";
import mobile1 from "../assets/mobile1.jpeg";
import mobile2 from "../assets/mobile2.jpeg";
import mobile3 from "../assets/moblile3.jpeg";

export const posters = [
  {
    src: a5,
  },

  {
    src: vl,
  },

  {
    src: flax,
  },
  {
    src: gym,
  },

  {
    src: hospital2,
  },
  {
    src: sabja,
  },
  {
    src: mw,
  },
  {
    src: newYear,
  },
  {
    src: a4,
  },
];

export const websites = [
  {
    src: web1,
    href: "https://pickurcar.com/",
  },
  {
    src: web2,
    href: "http://oldmuscattourism.com/",
  },
  {
    src: web3,
    href: "http://abetcoalbadigroup.com/",
  },
  {
    src: web4,
    href: "https://alqanoobi.net/",
  },
  {
    src: web5,
    href: "http://haifaoman.com/",
  },
  {
    src: web6,
    href: "http://seehalsarya.com/",
  },
];

export const logos = [
  {
    src: logo1,
  },
  {
    src: logo2,
  },
  {
    src: logo3,
  },
  {
    src: logo4,
  },
  {
    src: logo5,
  },
  {
    src: logo6,
  },
];

export const mobileApps = [
  {
    name: "Music App",
    src: mobile1,
  },
  {
    name: "Ecommerse App",
    src: mobile2,
  },
  {
    name: "Payment Transfer App",
    src: mobile3,
  },
];
